import { Component } from '@angular/core';
import { MatTab, MatTabChangeEvent, MatTabContent, MatTabGroup } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DataSourcesComponent } from './data-sources/data-sources.component';
import { FormAutofillComponent } from './form-field-mapping/form-autofill.component';
import { TableViewWidgetMappingsComponent } from './table-view-widget-mappings/table-view-widget-mappings.component';
import { WidgetRequestsComponent } from './widget-requests/widget-requests.component';

@Component({
  imports: [
    MatTab,
    MatTabGroup,
    TranslatePipe,
    DataSourcesComponent,
    WidgetRequestsComponent,
    MatTabContent,
    TableViewWidgetMappingsComponent,
    FormAutofillComponent,
  ],
  selector: 'app-data-integrations',
  styleUrl: './data-integrations.component.scss',
  templateUrl: './data-integrations.component.html',
})
export class DataIntegrationsComponent {
  public dataSourcesTabSelect$: Subject<void> = new Subject<void>();
  public widgetRequestsTabSelect$: Subject<void> = new Subject<void>();
  public tableViewWidgetMappingTabSelect$: Subject<void> = new Subject<void>();
  public formAutofillTabSelect$: Subject<void> = new Subject<void>();

  public changeTabActions($event: MatTabChangeEvent): void {
    switch ($event.index) {
      case 0:
        this.dataSourcesTabSelect$.next();

        break;
      case 1:
        this.widgetRequestsTabSelect$.next();

        break;
      case 2:
        this.tableViewWidgetMappingTabSelect$.next();

        break;

      case 3:
        this.formAutofillTabSelect$.next();

        break;
    }
  }
}
